export default __webpack_public_path__ + "static/google-0386b17add9eb46e5ed6fa5a9a20ab72.svg";